import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import { clearUpdatedExamination, updateExamination } from '../../../store/actions/examinationsActions';
import TextField from '../../elements/form/TextField';
import TextareaField from '../../elements/form/TextareaField';
import RadioGroup from '../../elements/form/RadioGroup';
import { Switch } from '@headlessui/react';
import DateField from '../../elements/form/DateField';
import moment from 'moment';
import TimeInputField from '../../elements/form/TimeInputField';
import TrashIcon from '../../elements/icons/TrashIcon';
import SelectField from '../../elements/form/SelectField';
import PlusIcon from '../../elements/icons/PlusIcon';
import NumberField from '../../elements/form/NumberField';

const EditExamination = ({examination, closeFunction, reload, description}) => {
    const dateObject = {
        date: "",
        startTime: "",
        endTime: ""
    }
    const dispatch = useDispatch()
    const feesSelector = useSelector(state => state.fees)
    const examinationsSelector = useSelector(state => state.examinations)
    const [examinationPayload, setExaminationPayload] = useState(examination ? 
        {...examination, ...{fee: examination?.fee?._id }} : {
        dates: [dateObject]
    });
    const [validationErrors, setValidationErrors] = useState({});
    const [requiresFee, setRequiresFee] = useState(examination?.fee ? true : false);
    useEffect(() => {
        // console.log('... ', feesSelector.fees?.fees )
        // console.log('... ', examinationPayload)
        if(examinationsSelector.updatedExamination !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'examination updated successfully!'
            })
            dispatch(clearUpdatedExamination())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [examinationsSelector.updatedExamination, dispatch, closeFunction]);

    const validateForm = () => {
        let errors = {}
        if(!examinationPayload.name || examinationPayload.name === '') {
            errors.name = true
        }
        if(!examinationPayload.description || examinationPayload.description === '') {
            errors.description = true
        }
        if(!examinationPayload.mode || examinationPayload.mode === '') {
            errors.mode = true
        }
        // if(!examinationPayload.location || examinationPayload.location === '') {
        //     errors.location = true
        // }
        if(!examinationPayload.dates || examinationPayload.dates.length === 0) {
            errors.dates = true
        }
        if(requiresFee && (!examinationPayload.fee || examinationPayload.fee === '')){
            errors.fee = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushFee = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(updateExamination(examination._id, examinationPayload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    const addDate = () => {
        let tempExamPayload = {...examinationPayload}
        tempExamPayload?.dates.push(dateObject)
        setExaminationPayload(tempExamPayload)
    }

    const removeDate = (dateIndex) => {
        let tempExamPayload = {...examinationPayload}
        tempExamPayload.dates.splice(dateIndex, 1)
        setExaminationPayload(tempExamPayload)
    }

    const updateDateTime = (index, field, value) =>{
        let tempExamPayload = {...examinationPayload}
        tempExamPayload.dates[index][field] = value
        setExaminationPayload(tempExamPayload)
    }

    const examModes = [
        {
            label: 'Online',
            value: 'ONLINE'
        },
        {
            label: 'Offline',
            value: 'OFFLINE'
        },
    ]

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>{description}</p>
            </div>
            <div className='mt-4'>
                <TextField
                    inputLabel="Examination name" 
                    fieldId="fee-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={examinationPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setExaminationPayload({...examinationPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Description" 
                    fieldId="fee-description" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={examinationPayload.description || ''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setExaminationPayload({...examinationPayload, ...{description: value}})}}
                />
            </div>

            <div className='mt-4'>
                <NumberField
                    inputType="number" 
                    fieldId={`passing-score`}
                    inputLabel="Passing Score (Percentage)" 
                    requiredField={true}
                    preloadValue={examinationPayload.passingScore || ''}
                    hasError={false} 
                    returnFieldValue={(value)=>{setExaminationPayload({...examinationPayload, ...{passingScore: value}})}}
                />
            </div>

            <div className='mt-4'>
                <RadioGroup 
                    items={examModes} 
                    inline={true}
                    preSelectedIndex={examModes.findIndex(item => item.value === examinationPayload.mode)}
                    inputLabel={'Exam mode'}
                    requiredField={true}
                    returnSelected={(value) => {setExaminationPayload({...examinationPayload, ...{mode: value.value}})}} 
                    hasError={validationErrors && validationErrors.religion}  
                    titleField='label'
                />
            </div>

            {/* <div className='mt-4'>
                <TextField
                    inputLabel="Location" 
                    fieldId="exam-location" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={examinationPayload.location || ''}
                    hasError={validationErrors && validationErrors.location} 
                    returnFieldValue={(value)=>{setExaminationPayload({...examinationPayload, ...{location: value}})}}
                />
            </div> */}

            <p className='text-sm mb-1 mt-4'>Examination dates</p>
            <p className='text-xs mb-1'>You can add multiple dates for this examination below by clicking on "add date". <br/><span className='text-red-500'>You must provide at least one date</span></p>
            {examination?.dates?.map((date, dateIndex)=>(
                <div key={dateIndex} className='relative mt-4 flex items-end justify-between gap-x-6'>
                    <div className="w-full">
                        <DateField
                            inputLabel="Examination Date" 
                            fieldId="exam-date" 
                            requiredField={true}
                            inputType="text" 
                            preloadValue={(moment(date.date).format('YYYY-MM-DD')) || ''}
                            hasError={validationErrors && validationErrors.dob} 
                            returnFieldValue={(value)=>{
                                const formattedDate = (moment(value, 'YYYY-MM-DD').format())
                                updateDateTime(dateIndex, 'date', formattedDate)}}
                        />
                    </div>
                    <div className="w-full">
                        <TimeInputField
                            inputLabel="Start time" 
                            fieldId="event-time" 
                            preloadValue={date.startTime || ''}
                            hasError={validationErrors.time} 
                            returnFieldValue={(value)=>{updateDateTime(dateIndex, 'startTime', value)}}
                        />
                    </div>
                    <div className="w-full">
                        <TimeInputField
                            inputLabel="End time" 
                            fieldId="event-time" 
                            preloadValue={date.endTime || ''}
                            hasError={validationErrors.time} 
                            returnFieldValue={(value)=>{updateDateTime(dateIndex, 'endTime', value)}}
                        />
                    </div>
                    {dateIndex > 0 && <div className="absolute -top-[5px] right-0 w-[20px] flex items-center justify-center">
                        <button onClick={()=>{removeDate(dateIndex)}} className='p-1 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                            <TrashIcon className={`w-5 h-5`} />
                        </button>
                    </div>}
                </div>
            ))}
            <div className='flex flex-row-reverse'>
                <button onClick={()=>{addDate()}} className='p-3 mt-3 rounded bg-transparent mb-[10px] bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-sm flex items-center justify-center text-vcm-purple hover:text-vcm-purple'> <PlusIcon className={`w-4 h-4`} /> Add date</button>
            </div>

            <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
                <div className='w-10/12'>
                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Requires fee</label>
                    <label className="text-xs text-gray-500 font-sofia-pro">Flip this switch if this examination requires a fee for entry.</label>
                </div>
                <div className='w-2/12 flex flex-row-reverse'>
                    <Switch
                        checked={requiresFee}
                        onChange={()=>{setRequiresFee(!requiresFee)}}
                        className={`${
                            requiresFee ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">Requires fee</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                requiresFee ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>

            </div>
            {requiresFee && <div className='mt-4 w-full'>
                {feesSelector.fees.fees.length > 0 ? <SelectField
                    selectOptions={feesSelector.fees.fees}
                    inputLabel="Select fee"
                    titleField="name"
                    displayImage={false}
                    imageField=""
                    requiredField={true}
                    preSelectedIndex={ examinationPayload.fee ? 
                        feesSelector.fees.fees.findIndex(item => 
                        item._id === examinationPayload.fee 
                    ) : ''}
                    preSelectedLabel="_id"
                    fieldId="fee-select"
                    hasError={validationErrors && validationErrors.status}
                    // return id of accounts of the selected option
                    returnFieldValue={(value) => {setExaminationPayload({...examinationPayload, ...{fee: value._id}})}}
                /> 
                : 
                <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                    <p>There are no fees yet. To be able to choose a fee for this examination, please navigate to fees on the left sidebar and create a fee.</p>
                </div>
                
            }
            </div>}

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update examination`}
                    buttonAction={()=>{pushFee()}}
                    processing={examinationsSelector.updatingExamination}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default EditExamination